/* * @Author: 曹俊杰 * @Date: 2024-10-25 23:14:21 * @Last Modified by: mikey.zhaopeng *
@Last Modified time: 2025-05-21 04:42:54 */
<template>
  <div class="byAdvisory">
    <div class="aliform" v-html="aliform" v-show="false"></div>
    <el-dialog :visible.sync="dialogVisible" width="860px">
      <div class="box1">
        <div class="box1-l">
          <div class="box1-l-content">
            <div class="box1-l-content-1">
              <div class="box1-l-content-1-l">选择服务套餐：</div>
              <div class="box1-l-content-1-r">
                {{
                  packageItem ? `咨询VIP（${packageItem.duration}个月）` : "未选择套餐"
                }}
              </div>
            </div>
            <div class="box1-l-content-2">
              <div class="box1-l-content-2-l">
                <p>我的代金券</p>
              </div>
              <div class="box1-l-content-2-r pointer">
                <div v-if="VoucherList.length == 0">暂无可用</div>
                <div v-else @click="showBox2Click">
                  <p v-if="voucherItem">-¥{{ voucherItem.amount | priceFormat }}</p>
                  <p v-else>{{ VoucherList.length }}张 代金劵</p>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="5"
                  height="8"
                  viewBox="0 0 5 8"
                  fill="none"
                >
                  <path
                    d="M0.714286 -3.12224e-08L2.00478e-08 0.666667L3.57143 4L-2.91409e-08 7.33333L0.714286 8L5 4L0.714286 -3.12224e-08Z"
                    fill="url(#paint0_linear_183_3225)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_183_3225"
                      x1="0.125"
                      y1="7.75"
                      x2="5"
                      y2="-6.57494e-07"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#fff" />
                      <stop offset="1" stop-color="#fff" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
            <div class="box1-l-content-3">
              <div
                class="box1-l-content-3-item pointer"
                :class="{ acitve: item.packageId == params.packageId }"
                v-for="item in AdvisoryPackage"
                :key="item.packgeId"
                @click="AdvisoryPackageClick(item)"
              >
                <div class="box1-l-content-3-item-1">{{ item.duration }}个月</div>
                <div class="box1-l-content-3-item-2">
                  <p>¥</p>
                  <div>{{ item.price | priceFormat }}</div>
                </div>
                <div class="box1-l-content-3-item-3">
                  ¥{{ item.originalPrice | priceFormat }}元
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box1-solid"></div>
        <div class="box1-r">
          <div class="box1-r-line1">
            <div class="box1-r-line1-l">实付金额</div>
            <div class="box1-r-line1-r">
              <p>¥</p>
              <div>{{ paymentAmount | priceFormat }}</div>
            </div>
          </div>

          <div class="box1-r-line2">
            <div class="box1-r-line2-l">
              {{
                packageItem ? `咨询VIP（${packageItem.duration}个月）` : "未选择套餐"
              }}：
            </div>
            <div class="box1-r-line2-r">
              <span v-if="packageItem">{{ packageItem.price | priceFormat }}</span>
              <span v-else>0.00</span>
            </div>
          </div>
          <div class="box1-r-line3">
            <div class="box1-r-line3-l">代金劵</div>
            <div class="box1-r-line3-r">
              <span v-if="voucherItem"> -¥{{ voucherItem.amount | priceFormat }} </span>
              <span v-else>0.00</span>
            </div>
          </div>
          <div style="height: 44px">
            <qiye v-model="qiye" v-if="!companyAuth" />
          </div>
          <div class="box1-r-line4">支付方式</div>
          <paymentMethod v-model="params.paymentMethod" :isbalance="isbalance" isBlack />

          <div class="box1-subbutton" @click="subbuttonClick">确认购买</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" :show-close="false" width="860px">
      <div class="box2">
        <div class="box2-title">
          <p>可用代金劵</p>
        </div>
        <div class="box2-content">
          <el-table
            :data="VoucherList"
            style="width: 100%"
            empty-text="暂无可用代金劵"
            @row-click="(row) => voucherClick(row)"
          >
            <el-table-column prop="amount" label="代金劵金额">
              <template slot-scope="scope">
                <span v-html="voucherAmountRender(scope.row)"></span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <div v-html="voucherTypeRender(scope.row)"></div>
              </template>
            </el-table-column>
            <el-table-column prop="validUntil" label="有效时间">
              <template slot-scope="scope">
                <div>
                  <div>起 - {{ scope.row.createdAt | timeFormat("yyyy-mm-dd") }}</div>
                  <div>止 - {{ scope.row.validUntil | timeFormat("yyyy-mm-dd") }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="state" label="状态">
              <template slot-scope="scope">
                <div v-html="voucherStateDataRender(scope.row)"></div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <div class="setting">
                  <img
                    style="width: 16px"
                    src="@/assets/image/home/select_y.webp"
                    alt=""
                    srcset=""
                    v-if="scope.row.voucherId === params.voucherId"
                  />
                  <img
                    style="width: 16px"
                    src="@/assets/image/home/select_n.png"
                    alt=""
                    srcset=""
                    v-else
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div
            class="box2-item pointer"
            v-for="item in VoucherList"
            :key="item.voucherId"
            @click="voucherClick(item)"
          >
            <div class="box2-item-t">
              <div class="box2-item-t-l">
                <div>{{ item.amount }}</div>
                <p class="icon">元</p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2"
                height="60"
                viewBox="0 0 2 60"
                fill="none"
              >
                <path opacity="0.5" d="M1 0V60" stroke="#A85E2E" stroke-dasharray="5 5" />
              </svg>
              <div class="box2-item-t-r">
                <div>法律咨询-代金券</div>
                <div v-if="item.voucherId === params.voucherId">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="15"
                      height="15"
                      rx="7.5"
                      stroke="#A85E2E"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="8"
                      height="8"
                      rx="4"
                      fill="url(#paint0_linear_189_397)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_189_397"
                        x1="4.26667"
                        y1="8"
                        x2="12"
                        y2="8"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#BC6416" />
                        <stop offset="1" stop-color="#914F1A" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div v-else>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <rect
                      opacity="0.5"
                      x="0.5"
                      y="0.5"
                      width="13"
                      height="13"
                      rx="6.5"
                      stroke="#A85E2E"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="box2-item-c"></div>
            <div class="box2-item-b">
              <div class="box2-item-b-l">有效期至：</div>
              <div class="box2-item-b-r">
                {{ item.validUntil | timeFormat("yyyy-mm-dd") }}
              </div>
            </div>
          </div> -->
        </div>
        <!-- <div class="box2-footer">
          <div class="box2-footer-btn" @click="box2BtnClick">确认</div>
        </div> -->
        <div class="box2-footer">
          <el-button size="mini" @click="box2Btnclose">取 消</el-button>
          <el-button type="primary" @click="box2BtnClick" size="mini">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="successBoax">
      <el-dialog :visible.sync="dialogVisible2" :show-close="false" width="448px">
        <div class="boxw">
          <img src="@/assets/image/zixun/img1.webp" class="bg" alt="" srcset="" />
          <div class="box3" @click="dialogVisible2 = false"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import userinfo from "@/mixins/userinfo.js";
import qiye from "./qiye.vue";
import paymentMethod from "@/components/paymentMethod/paymentMethod";
import selectData from "@/mixins/selectData";
export default {
  components: {
    qiye,
    paymentMethod,
  },
  mixins: [userinfo, selectData],
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      AdvisoryPackage: [], // 套餐列表
      VoucherList: [], //代金券列表
      params: {
        packageId: null,
        voucherId: null,
        paymentMethod: 1,
      },
      aliform: "",
      qiye: false,
    };
  },
  watch: {
    qiye: {
      async handler() {
        // this.params.packageId = null;
        const index = this.AdvisoryPackage.findIndex(
          (res) => res.packageId == this.params.packageId
        );
        await this.getAdvisoryPackage();
        if (index !== -1) {
          this.params.packageId = this.AdvisoryPackage[index].packageId;
        }
      },
      immediate: true,
    },
  },
  computed: {
    packageItem() {
      //选中的套餐
      const { packageId } = this.params;
      return this.AdvisoryPackage.find((r) => r.packageId == packageId);
    },
    voucherItem() {
      //  选中的代金券
      const { voucherId } = this.params;
      return this.VoucherList.find((r) => r.voucherId == voucherId);
    },
    paymentAmount() {
      //支付金额
      const { packageItem, voucherItem } = this;
      if (packageItem) {
        //如果选中套餐  就输出套餐金额
        if (voucherItem) {
          // 如果选中代金券  就输出套餐 减去代金券金额
          const price = packageItem.price - voucherItem.amount;
          return price < 0 ? 0 : price; //如果小于0  就输出0
        } else {
          return packageItem.price;
        }
      } else {
        return 0;
      }
    },
    isbalance() {
      //  余额是否够
      return this.balance - this.paymentAmount >= 0;
    },
    //  咨询服务的版本
    edition() {
      if (this.companyAuth) {
        return 1;
      }
      if (this.qiye) {
        return 1;
      }
      return 0;
    },
  },
  created() {
    // this.getAdvisoryPackage()
    this.getVoucherList();
  },
  methods: {
    clearData() {
      this.params = {
        packageId: null,
        voucherId: null,
        paymentMethod: null,
      };
    },
    show() {
      this.dialogVisible = true;
    },
    //套餐列表   版本: 0-个人版, 1-企业版
    async getAdvisoryPackage() {
      const { status, data } = await this.$api.getAdvisoryPackage({
        edition: this.edition,
      });
      if (status === 200) {
        this.AdvisoryPackage = data;
      }
    },
    handleClose() {},
    //套餐点击
    AdvisoryPackageClick(item) {
      const { packageId } = item;
      if (this.params.packageId == packageId) {
        this.params.packageId = null;
      } else {
        this.params.packageId = packageId;
      }
    },
    // 代金券点击
    voucherClick(item) {
      const { voucherId } = item;
      if (this.params.voucherId == voucherId) {
        this.params.voucherId = null;
      } else {
        this.params.voucherId = voucherId;
      }
    },
    // 代金券确认
    box2BtnClick() {
      this.dialogVisible1 = false;
    },
    box2Btnclose() {
      this.params.voucherId = null;
      this.dialogVisible1 = false;
    },
    //显示代金券选择菜单
    showBox2Click() {
      this.dialogVisible1 = true;
    },
    async getVoucherList() {
      const { status, data } = await this.$api.getVoucherList({ type: 1, state: 0 });
      if (status === 200) {
        this.VoucherList = data.records;
      }
    },
    // //余额那一行的点击事件
    // yuelineclick() {
    //     //  如果余额够用  选中余额支付   否则跳转充值页
    //     if (this.isbalance) {
    //         this.params.paymentMethod = 1
    //     } else {
    //         this.tochongzhi();
    //         this.dialogVisible = false;
    //     }

    // },
    // // 支付宝那一行的点击事件
    // zhifubaolineClick() {
    //     this.params.paymentMethod = 2
    // },
    //  确认购买
    async subbuttonClick() {
      const { packageId, voucherId, paymentMethod } = this.params;
      if (!packageId) {
        this.$message({ type: "error", message: "请选择充值套餐！" });
        return;
      }
      if (!paymentMethod) {
        this.$message({ type: "error", message: "请选择支付方式！" });
        return;
      }
      if (paymentMethod == 1 && !this.isbalance) {
        this.$message({ type: "error", message: "余额不够请充值！" });
        return;
      }
      if (this.qiye) {
        this.$store.dispatch("user/toAccountCompanyAuth");
        return;
      }
      if (paymentMethod == 1) {
        //余额购买 弹出确认弹窗。。。。
        try {
          await this.$confirm("是否使用余额购买?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        } catch (error) {
          return;
        }
      }

      this.postAdvisory();
    },
    // 请求购买咨询
    async postAdvisory() {
      const { paymentMethod } = this.params;
      const { status, info, data } = await this.$api.postAdvisory(this.params);
      if (status === 200) {
        if (paymentMethod == 1) {
          this.dialogVisible = false;
          this.dialogVisible2 = true;
        } else if (paymentMethod == 2) {
          this.aliform = data;
          this.$nextTick(() => {
            document.forms[0].submit(); //重点--这个才是跳转页面的核心,获取第一个表单并提交
          });
        }
        this.$emit("success");
        this.clearData();
      } else {
        this.$message({
          type: "error",
          message: info,
        });
        this.$emit("success");
      }
    },
    //开始咨询
    kefu() {
      this.dialogVisible2 = false;
      this.$im.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.byAdvisory {
  &::v-deep.el-dialog {
    background: transparent;
    box-shadow: none;

    &__header {
      padding: 0;
    }

    &__body {
      padding: 0;
    }
  }

  .box1 {
    width: 860px;
    display: flex;
    border-radius: 6px;
    overflow: hidden;

    &-l {
      width: 560px;
      //   background: linear-gradient(180deg, #ffefce 0%, #fff 100%);

      padding-top: 60px;
      background-image: url(~@/assets/image/zixun/img2.webp);
      background-size: 100% auto;
      background-color: #404066;

      &-content {
        padding: 0 16px;

        &-1 {
          display: flex;
          height: 60px;
          align-items: center;
          justify-content: space-between;

          &-l {
            background: linear-gradient(180deg, #ffe8ad 0%, #fff6df 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            text-shadow: 0px 6px 8px rgba(0, 89, 255, 0.1);
            font-family: "Noto Sans SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }

          &-r {
            background: linear-gradient(180deg, #ffe8ad 0%, #fff6df 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            text-shadow: 0px 6px 8px rgba(0, 89, 255, 0.1);
            font-family: "Noto Sans SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }

        &-2 {
          display: flex;
          height: 38px;
          flex-shrink: 0;
          border-radius: 4px;
          background: #545484;
          align-items: center;
          justify-content: space-between;
          padding: 0 15px;

          &-l {
            color: #ffffff;
            font-family: "Noto Sans SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 350;
            line-height: normal;
            display: flex;
            align-items: center;

            p {
              margin-left: 6px;
            }
          }

          &-r {
            color: #ffffff;
            font-family: "Noto Sans SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            display: flex;
            align-items: center;

            p {
              margin-right: 6px;
            }
          }
        }

        &-3 {
          padding-bottom: 20px;
          display: grid;
          grid-template-columns: repeat(2, 1fr); /* 两列 */
          grid-template-rows: repeat(2, auto); /* 两行 */
          gap: 16px; /* 同时设置 row-gap 和 column-gap 为 16px */
          margin-top: 16px;
          &-item {
            width: 256px;
            height: 135px;
            flex-shrink: 0;
            border-radius: 4px;

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background-image: url(~@/assets/image/zixun/img4.webp);
            background-size: 100% auto;
            &-1 {
              color: #ffffff;
              opacity: 0.5;
              font-family: "Noto Sans SC";
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            }

            &-2 {
              margin-top: 6px;
              display: flex;
              font-family: "Noto Sans SC";
              font-size: 30px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
              align-items: flex-end;
              color: #ffe194;

              p {
                font-family: "Noto Sans SC";
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                margin-bottom: 4px;
              }
            }

            &-3 {
              color: #ffffff;
              opacity: 0.5;
              font-family: "Noto Sans SC";
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              text-decoration: line-through;
              margin-top: 8px;
            }
          }

          .acitve {
            border-radius: 4px;
            background-image: url(~@/assets/image/zixun/img5.webp);
            .box1-l-content-3-item-1 {
              color: #434862;
            }
            .box1-l-content-3-item-2 {
              color: #434862;
            }

            .box1-l-content-3-item-3 {
              color: #434862;
              font-family: "Noto Sans SC";
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              text-decoration-line: strikethrough;
            }
          }
        }
      }
    }

    // &-solid {
    //   width: 1px;
    //   // height: 1000px;
    //   // flex-shrink: 0;
    //   background: #eaca99;
    // }

    &-r {
      width: 300px;
      background-image: url(~@/assets/image/zixun/img3.webp);
      padding: 40px 16px 16px;
      background-color: #303149;
      background-size: 100% 100%;
      &-line1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 60px;
        border-bottom: 1px dashed #e3e3e3;

        // background: #f66;
        &-l {
          color: #ffe194;
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }

        &-r {
          display: flex;
          color: #ffe194;
          font-family: "Noto Sans SC";
          font-size: 30px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          align-items: flex-end;

          p {
            color: #ffe194;
            font-family: "Noto Sans SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin-bottom: 4px;
            margin-right: 4px;
          }
        }
      }

      &-line2 {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-l {
          color: #ffffff;
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }

        &-r {
          color: #ffffff;
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }

      &-line3 {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-l {
          color: #ffffff;
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }

        &-r {
          color: #ffe194;
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }

      &-line4 {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        color: #ffffff;
        opacity: 0.5;
      }

      &-line5 {
        width: 280px;
        height: 44px;
        flex-shrink: 0;
        border-radius: 4px;
        background: #fff;
        display: flex;
        align-items: center;
        padding: 0 16px;
        justify-content: space-between;

        &-l {
          display: flex;
          align-items: center;
          color: #262626;
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }

        &-r {
          color: #0062ff;
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }

        &-r {
          .box1-r-icon1 {
            display: none;
          }

          .box1-r-icon2 {
            display: block;
          }
        }
      }

      &-line6 {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        width: 280px;
        height: 44px;
        flex-shrink: 0;
        border-radius: 4px;

        background: #fff;

        &-l {
          display: flex;
          align-items: center;

          p {
            margin-left: 6px;
            color: #262626;
            font-family: "Noto Sans SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
        }

        &-r {
          .box1-r-icon1 {
            display: none;
          }

          .box1-r-icon2 {
            display: block;
          }
        }
      }

      &-active {
        border: 1px solid #0062ff;

        .box1-r-icon2 {
          display: none;
        }

        .box1-r-icon1 {
          display: block;
        }
      }
    }

    &-subbutton {
      cursor: pointer;
      margin: 0 auto;
      margin-top: 16px;
      border-radius: 4px;
      width: 266px;
      height: 40px;
      flex-shrink: 0;
      color: #303149;
      text-align: center;
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
      background: #ffe194;
    }
  }

  .box2 {
    // width: 460px;
    // background: linear-gradient(180deg, #ffefce 0%, #fff 100%);
    // margin: 0 auto;
    // border-radius: 6px;
    // overflow: hidden;
    &-title {
      height: 60px;
      padding: 0 16px;
      display: flex;
      align-items: center;

      font-size: 18px;
      font-weight: 500;
      color: #262626;
    }

    &-content {
      // margin-top: 35px;
      height: 400px;
      overflow-y: auto;
      padding: 0 16px;
    }

    // &-item {
    //   margin: 0 auto;
    //   border-radius: 10px;
    //   overflow: hidden;
    //   width: 390px;
    //   height: 120px;
    //   margin-bottom: 20px;

    //   &-t {
    //     width: 390px;
    //     height: 88px;
    //     background: linear-gradient(90deg, #feeacd 0%, #fbd19c 100%);
    //     display: flex;
    //     align-items: center;

    //     &-l {
    //       width: 147px;
    //       color: #a85e2e;
    //       font-family: "Noto Sans SC";
    //       font-size: 46px;
    //       font-style: normal;
    //       font-weight: 700;
    //       display: flex;
    //       align-items: center;
    //       justify-content: center;

    //       .icon {
    //         color: #a85e2e;
    //         font-family: "Noto Sans SC";
    //         font-size: 16px;
    //         font-style: normal;
    //         font-weight: 400;
    //         line-height: normal;
    //         margin-top: 16px;
    //         margin-left: 6px;
    //       }
    //     }

    //     &-r {
    //       flex: 1;
    //       display: flex;
    //       padding: 0 30px;
    //       align-items: center;
    //       justify-content: space-between;
    //       font-family: "Noto Sans SC";
    //       font-size: 18px;
    //       font-style: normal;
    //       font-weight: 700;
    //       line-height: normal;
    //       background: linear-gradient(90deg, #bc6416 3.33%, #914f1a 100%);
    //       background-clip: text;
    //       -webkit-background-clip: text;
    //       -webkit-text-fill-color: transparent;
    //     }
    //   }

    //   &-c {
    //     width: 390px;
    //     height: 1px;
    //     flex-shrink: 0;
    //     background: linear-gradient(90deg, #fffaf1 0%, #fed993 100%);
    //   }

    //   &-b {
    //     width: 390px;
    //     height: 32px;
    //     flex-shrink: 0;
    //     background: linear-gradient(90deg, #f6d8aa 0%, #f4c283 100%);
    //     display: flex;
    //     padding: 0 30px;
    //     align-items: center;
    //     justify-content: space-between;
    //     color: #93502b;
    //     font-family: "Noto Sans SC";
    //     font-size: 14px;
    //     font-style: normal;
    //     font-weight: 400;
    //     line-height: normal;
    //   }
    // }

    &-footer {
      height: 64px;
      padding: 0 16px;
      flex-shrink: 0;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
  .successBoax {
    ::v-deep .el-dialog {
      background-color: rgba($color: #000000, $alpha: 0);
      box-shadow: none;
      margin-top: 0px !important;
    }
    .boxw {
      position: relative;
      overflow: hidden;
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .bg {
      width: 448px;
      height: 360px;
      position: absolute;
      top: 14px;
      left: -10px;
      z-index: 1;
      animation: spin 10s linear infinite;
    }
    .box3 {
      position: relative;
      z-index: 2;
      width: 448px;
      height: 360px;
      background-image: url(~@/assets/image/zixun/img7.webp);
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding-bottom: 30px;
      background-size: 100% auto;
    }
  }
}
</style>
